import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import emptyStateImage from 'assets/img/icn-empty-state.svg';
import * as actions from '../action';
import * as c from '../constant';

function TaxAmnestyContent({
  handleAddModal,
  handleEdit,
  handleDelete,
  taxAmnestyId,
  getSingleTaxAmnesty,
  taxAmnestyInfo,
}) {
  useEffect(() => {
    if (_.isEmpty(taxAmnestyId)) return;
    getSingleTaxAmnesty(taxAmnestyId);
  }, []);
  useEffect(() => {
    if (_.isEmpty(taxAmnestyId)) return;
    getSingleTaxAmnesty(taxAmnestyId);
  }, [taxAmnestyId]);

  return (
    <div className="container-fluid card-section-content">
      <div className="card-body">
        <div className="row pt-4 pb-2 bg-white">
          <div className="col-12 d-flex">
            <button
              type="button"
              onClick={handleAddModal}
              className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-round font-weight-bold px-4 ml-auto"
            >
              Add Tax Amnesty &nbsp;&nbsp;
              <i className="fas fa-plus" />
            </button>
          </div>
        </div>
        {!_.isEmpty(taxAmnestyInfo) ? (
          <React.Fragment>
            <div className="row bg-white pb-3">
              <div className="col-8">
                <h2 className="">
                  {_.get(taxAmnestyInfo, 'attributes.name')}
                </h2>
                <span className="full-input">
                  {_.get(taxAmnestyInfo, 'attributes.description')}
                </span>
              </div>
              <div className="col-4 d-flex">
                <div className="py-3 ml-auto">
                  <button
                    type="button"
                    className="btn-blank"
                    onClick={handleEdit(taxAmnestyInfo)}
                  >
                    <i className="far fa-edit icon-edit" />
                  </button>
                  <button
                    type="button"
                    className="btn-blank"
                    onClick={handleDelete(taxAmnestyInfo)}
                  >
                    <i className="far fa-trash-alt icon-delete" />
                  </button>
                </div>
              </div>
              <div className="col-12">
                <div className="form-wrapper mb-3 p-3">
                  <table className="transaction-table table table-borderless table-sm ">
                    <tbody>
                      <tr>
                        <td className="text-dark" width="250">
                          Name
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {_.get(taxAmnestyInfo, 'attributes.name')}
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          Description
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {_.get(
                              taxAmnestyInfo,
                              'attributes.description'
                            )}
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          Ordinance
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td>
                          <b>
                            {_.get(taxAmnestyInfo, 'attributes.ordinance')}
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          Effectivity Start
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {_.get(
                              taxAmnestyInfo,
                              'attributes.effectivity_start_human'
                            )}
                          </b>
                        </td>
                      </tr>
                      <tr>
                        <td className="text-dark" width="250">
                          Effectivity End
                        </td>
                        <td className="text-dark" width="1">
                          :
                        </td>
                        <td colSpan={4}>
                          <b>
                            {_.get(
                              taxAmnestyInfo,
                              'attributes.effectivity_end_human'
                            )}
                          </b>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </React.Fragment>
        )
          : (
            <div className="d-flex align-items-center justitfy-content-center h-100">
              <div className="text-center mx-auto py-4">
                <img
                  src={emptyStateImage}
                  className="img-responsive image-wrapper mb-4 mt-3"
                  alt="Empty State"
                />
                <p className="emp-title mb-0"> No Item Found </p>
              </div>
            </div>
          )}
      </div>
    </div>
  );
}

TaxAmnestyContent.propTypes = {
  handleAddModal: PropTypes.instanceOf(Function).isRequired,
  handleEdit: PropTypes.instanceOf(Function).isRequired,
  handleDelete: PropTypes.instanceOf(Function).isRequired,
  getSingleTaxAmnesty: PropTypes.instanceOf(Function).isRequired,
  taxAmnestyInfo: PropTypes.instanceOf(Object).isRequired,
  taxAmnestyId: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match }) => ({
  taxAmnestyInfo:
    _.get(api, `${c.GET_SINGLE_TAX_AMNESTY}.item`) || {},
  taxAmnestyId: _.get(match, 'params.taxAmnestyId') || '',
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(TaxAmnestyContent);
